{
  "enum": {
    "IxtE2eV1TestRunStatus": {
      "CANCELED": "Canceled",
      "FAILURE": "Failure",
      "RUNNING": "Running",
      "SUCCESS": "Success",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxtE2eV1TestRunQueryServiceTestRunListFilterableFields": {
      "environment": "Environment",
      "status": "Status",
      "testRunId": "Test Run"
    }
  },
  "oneOf": {
    "IxtE2eV1TestRunEventType": {
      "canceled": "Canceled",
      "failed": "Failed",
      "submitted": "Submitted",
      "succeeded": "Succeeded"
    }
  },
  "sortEnum": {
    "IxtE2eV1TestRunQueryServiceTestRunListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}